import { render, staticRenderFns } from "./Nueva-nota-de-credito.vue?vue&type=template&id=bd6ab380"
import script from "./Nueva-nota-de-credito.vue?vue&type=script&lang=js"
export * from "./Nueva-nota-de-credito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports